import {
  Component,
  ElementRef,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  OnInit
} from '@angular/core'
import { FileUploader, FileUploaderOptions, FileItem } from 'ng2-file-upload'
import { ToastrService } from 'ngx-toastr'
import { Subject } from 'rxjs'

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  standalone: false
})
export class UploadComponent implements OnDestroy, OnInit {
  public uploader: FileUploader
  private uploaderOptions = {} as FileUploaderOptions

  @ViewChild('fileInput', { static: true })
  fileInput: ElementRef

  @Output()
  fileUploaded = new EventEmitter<any>()
  @Output()
  customUpload = new EventEmitter<any>()

  private destroySubject: Subject<void>
  @Input()
  appendFileName = false
  @Input()
  set url(value: string) {
    this.uploaderOptions.url = value
  }
  get url(): string {
    return this.uploaderOptions.url
  }
  @Input()
  set allowedFileType(value: string[]) {
    this.uploaderOptions.allowedFileType = value
  }
  get allowedFileType(): string[] {
    return this.uploaderOptions.allowedFileType
  }
  @Input()
  set allowedMimeType(value: string[]) {
    this.uploaderOptions.allowedMimeType = value
  }
  get allowedMimeType(): string[] {
    return this.uploaderOptions.allowedMimeType
  }
  @Input()
  set maxFileSize(value: number) {
    this.uploaderOptions.maxFileSize = value
  }
  get maxFileSize(): number {
    return this.uploaderOptions.maxFileSize
  }

  public hasBaseDropZoneOver = false

  constructor(private toastr: ToastrService) {
    this.destroySubject = new Subject<void>()
  }

  ngOnInit(): void {
    const token = 'Bearer ' + window.sessionStorage.getItem('access_token')
    this.uploaderOptions.authToken = token
    this.uploader = new FileUploader(this.uploaderOptions)

    this.uploader.onAfterAddingFile = file => {
      this.toastr.clear()
      file.withCredentials = false
      if (this.appendFileName) {
        file.url = this.uploader.options.url + file.file.name
      }
    }

    this.uploader.onErrorItem = (_file, response, status) => {
      if (response === '') {
        this.toastr.error('Error: no response was given')
        return
      }
      let err: any = JSON.parse(response)
      if (status === 412) {
        err.value.map((x: string) => this.toastr.error(x))
      } else {
        err = err.error
        let msg = ''
        if (err.message) {
          msg = err.message
        }
        if (err.innererror && err.innererror.message) {
          msg = err.innererror.message
        }
        this.toastr.error(msg)
      }
    }

    this.uploader.onSuccessItem = (item, _response, _status) => {
      this.toastr.clear()
      this.fileUploaded.emit(item.file.name)
    }
  }

  ngOnDestroy(): void {
    this.destroySubject.next()
    this.destroySubject.complete()
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e
  }

  public openFileDialog(): void {
    const event = new MouseEvent('click', { bubbles: false })
    this.fileInput.nativeElement.dispatchEvent(event)
  }

  public getFileSize(value: number): string {
    const factors: number[] = [
      0.125, // b
      0.0001220703125, // kb
      1.1920928955078e-7, // mb
      1.1641532182693e-10, // gb
      1.1368683772162e-13 // tb
    ]

    function fixIt(v: any) {
      if (!isFinite(v)) {
        return ''
      }
      if (v === 0) {
        return '0'
      }
      const st = '' + v
      let epos = st.indexOf('E')
      if (epos === -1) {
        epos = st.indexOf('e')
      }
      const sdigi = Math.log(Math.abs(v)) / Math.LN10
      const sdigif = Math.floor(sdigi)
      if (epos === -1) {
        const adjust = Math.pow(10, sdigif - 12)
        const faqs = Math.round(v / adjust)
        if (sdigif < 12) {
          return faqs / Math.pow(10, 12 - sdigif)
        } else {
          return faqs * adjust
        }
      } else {
        const zo = v * Math.pow(10, 12 - sdigif)
        const szo = String(Math.round(zo))
        const inse = szo.charAt(0) === '-' ? 2 : 1

        let rest = szo.substring(inse, szo.length)
        let i = rest.length - 1
        while (i >= 0 && rest.charAt(i) === '0') {
          i--
        }
        rest = rest.substring(0, i + 1)
        let rou = szo.substring(0, inse)
        if (rest.length > 0) {
          rou += '.' + rest
        }
        let sa = rou + 'E+'
        if (sdigif < 0) {
          sa = rou + 'E'
        }
        let snow = sa + sdigif
        let vanow = Math.abs(parseFloat(snow))
        const faqsvab = Math.abs(v)
        if (sdigif >= 0) {
          if (vanow > 5 * faqsvab) {
            snow = sa + String(sdigif - 1)
          } else if (vanow < faqsvab / 5) {
            snow = sa + String(sdigif + 1)
          }
        }
        vanow = parseFloat(snow)

        return vanow > 1.1 * v || vanow < 0.9 * v ? v : snow
      }
    }

    let faqsorg = factors[2] / factors[0]
    let resfaqs = value * faqsorg
    let suffix = 'MB'
    if (resfaqs < 1) {
      faqsorg = factors[1] / factors[0]
      resfaqs = value * faqsorg
      suffix = 'KB'
    }
    return isNaN(resfaqs) ? '' : +fixIt(resfaqs).toFixed(2) + ' ' + suffix
  }

  public itemUpload(item: FileItem): void {
    this.toastr.clear()
    if (this.customUpload.observed) {
      this.customUpload.emit(item)
    } else {
      item.upload()
    }
  }

  public itemCancel(item: FileItem): void {
    this.toastr.clear()
    item.cancel()
  }

  public itemRemove(item: FileItem): void {
    this.toastr.clear()
    item.remove()
  }

  onFileClick(event: any) {
    event.target.value = ''
  }
}
